module.exports = __webpack_public_path__ + "img/mydr-edm.9500a9ea.svg";